
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface StatusSelectorProps {
  value: string | null;
  onChange: (value: string) => void;
  onClear: () => void;
  showFilterBar?: boolean;
}

export const SubscriptionStatusSelector: React.FC<StatusSelectorProps> = ({
  value,
  onChange,
  onClear,
  showFilterBar = false
}) => {
  if (showFilterBar) {
    return (
      <div className="flex items-center gap-2 p-2 bg-muted/50 rounded-lg">
        <span className="text-sm text-muted-foreground">Статус:</span>
        <div className="font-medium text-sm">{value === 'active' ? 'Активна' :
                           value === 'cancelled' ? 'Отменена' :
                           value === 'paused' ? 'Приостановлена' : 'Все'}</div>
        <Button variant="ghost" size="icon" onClick={onClear} className="h-5 w-5">
          <X className="h-3 w-3" />
        </Button>
      </div>
    );
  }

  return (
    <Select value={value || 'all'} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Статус подписки" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Все статусы</SelectItem>
        <SelectItem value="active">Активные</SelectItem>
        <SelectItem value="paused">Приостановленные</SelectItem>
        <SelectItem value="cancelled">Отмененные</SelectItem>
      </SelectContent>
    </Select>
  );
};
